/* promomarka.360 · movimiento: apariciones al hacer scroll, contadores, palabras rotativas, inclinación 3D y cabecera. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;
  root.classList.add('pm-js');

  // ---------- Apariciones al hacer scroll ----------
  const SELECTORES = [
    '.pm-head', '.pm-cat', '.pm-step', '.pm-tech__card', '.pm-tech__intro', '.pm-promo', '.pm-tarjeta',
    '.pm-cta__inner', '.pm-medida__copy', '.pm-medida__fases li', '.pm-seo__guia', '.pm-faq__item',
    '.pm-probador__escena', '.pm-probador__panel', '.pm-dtf__visor', '.pm-dtf__tabs li', '.pm-footer__grid > *',
    '.pm-contenido', '.pm-hero__stats li',
  ];
  function prepararReveal(ambito = document) {
    const els = ambito.querySelectorAll(SELECTORES.join(','));
    els.forEach((el) => {
      if (el.dataset.pmReveal) return;
      el.dataset.pmReveal = '1';
      const hermanos = el.parentElement ? [...el.parentElement.children].filter((c) => c.dataset.pmReveal) : [];
      el.style.setProperty('--pm-d', `${Math.min(hermanos.indexOf(el), 8) * 70}ms`);
      el.classList.add('pm-reveal');
    });
    return els;
  }
  const io = !reduce && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('pm-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;
  function observar(ambito) {
    const els = prepararReveal(ambito);
    els.forEach((el) => (io ? io.observe(el) : el.classList.add('pm-in')));
  }

  // ---------- Contadores (+1.800 → cuenta desde 0) ----------
  function contadores(ambito = document) {
    ambito.querySelectorAll('[data-pm-count]').forEach((el) => {
      if (el.dataset.pmCounted) return;
      el.dataset.pmCounted = '1';
      const original = el.textContent.trim();
      const m = original.match(/^([^\d]*)([\d.]+)(.*)$/);
      if (!m || reduce) return;
      const objetivo = parseInt(m[2].replace(/\./g, ''), 10);
      if (!objetivo) return;
      const fmt = (n) => n.toLocaleString('es-ES');
      el.textContent = m[1] + '0' + m[3];
      const arrancar = () => {
        const t0 = performance.now(), dur = 1400;
        const paso = (t) => {
          const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
          el.textContent = m[1] + fmt(Math.round(objetivo * e)) + m[3];
          if (k < 1) requestAnimationFrame(paso); else el.textContent = original;
        };
        requestAnimationFrame(paso);
      };
      const o = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { arrancar(); o.disconnect(); } }), { threshold: 0.6 });
      o.observe(el);
    });
  }

  // ---------- Palabras rotativas del titular ----------
  function rotativas(ambito = document) {
    ambito.querySelectorAll('[data-pm-rotate]').forEach((el) => {
      if (el.dataset.pmRotating) return;
      el.dataset.pmRotating = '1';
      const palabras = el.dataset.pmRotate.split('|').map((s) => s.trim()).filter(Boolean);
      if (palabras.length < 2 || reduce) return;
      let i = 0;
      const ancho = () => { el.style.minWidth = ''; };
      setInterval(() => {
        el.classList.add('pm-rot-out');
        setTimeout(() => {
          i = (i + 1) % palabras.length;
          el.textContent = palabras[i];
          el.classList.remove('pm-rot-out');
          el.classList.add('pm-rot-in');
          setTimeout(() => el.classList.remove('pm-rot-in'), 450);
          ancho();
        }, 320);
      }, 2600);
    });
  }

  // ---------- Inclinación 3D al mover el ratón ----------
  function inclinacion(ambito = document) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    ambito.querySelectorAll('[data-pm-tilt]').forEach((el) => {
      if (el.dataset.pmTiltOn) return;
      el.dataset.pmTiltOn = '1';
      const max = parseFloat(el.dataset.pmTilt) || 6;
      let raf;
      el.addEventListener('mousemove', (ev) => {
        const r = el.getBoundingClientRect();
        const x = (ev.clientX - r.left) / r.width - 0.5, y = (ev.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          el.style.setProperty('--pm-rx', `${(-y * max).toFixed(2)}deg`);
          el.style.setProperty('--pm-ry', `${(x * max).toFixed(2)}deg`);
          el.style.setProperty('--pm-mx', `${(x * 100 + 50).toFixed(1)}%`);
          el.style.setProperty('--pm-my', `${(y * 100 + 50).toFixed(1)}%`);
        });
      });
      el.addEventListener('mouseleave', () => { el.style.setProperty('--pm-rx', '0deg'); el.style.setProperty('--pm-ry', '0deg'); });
    });
  }

  // ---------- Cabecera compacta al hacer scroll ----------
  function cabecera() {
    const h = document.querySelector('.section-header');
    if (!h) return;
    let ultimo = false;
    const f = () => { const s = window.scrollY > 40; if (s !== ultimo) { h.classList.toggle('pm-scrolled', s); ultimo = s; } };
    window.addEventListener('scroll', f, { passive: true });
    f();
  }

  function iniciar(ambito) { observar(ambito); contadores(ambito); rotativas(ambito); inclinacion(ambito); }
  window.pmMotion = { iniciar };

  document.addEventListener('DOMContentLoaded', () => { iniciar(document); cabecera(); });
  // Editor de temas: re-inicializa al recargar secciones.
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
